module.exports = __webpack_public_path__ + "img/shouye.85584f84.png";